import Vue from "vue"
import StaticData from '@/data/static-data.js';


Vue.filter('anoLectivoDesc', function (value) {
	let anoLectivo = StaticData.AnosLectivos.find(item => item.value === value)
	// console.log('anoLectivo: ', anoLectivo);

	if (anoLectivo) {
		return anoLectivo.text;
	}
	return "";
})

Vue.filter('percentage', function (value, decimals, applySign) {
	if (decimals == null) {
		decimals = 2;
	}
	if (applySign == null) {
		applySign = true;
	}

	if (value == null || isNaN(value)) {
		return null;
	}
	else {
		return (value * 100).toFixed(decimals) + (applySign ? '%' : '');
	}
})